import Seo from "@/components/feature/Seo";
import { brand } from "@/mocks/siteData";
import Hero from "./components/Hero";
import CharactersSection from "./components/CharactersSection";
import RelationshipSection from "./components/RelationshipSection";
import SettingPreview from "./components/SettingPreview";
import StoryPreview from "./components/StoryPreview";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "洞洞杂货铺 · 角色与设定科普站",
  url: "/",
  inLanguage: "zh-CN",
  description: brand.description,
};

export default function Home() {
  return (
    <>
      <Seo
        title="洞洞杂货铺漫画｜店主是谁·主要人物关系与店铺设定大全"
        description="洞洞杂货铺漫画角色介绍一页铺开：认识洞洞杂货铺店主、主要人物关系图与店铺设定细节，帮你快速认清漫画里的每个人，理解墙上的洞与村庄的百年秘密。"
        keywords="洞洞杂货铺漫画,洞洞杂货铺角色介绍,洞洞杂货铺店主,洞洞杂货铺主要人物,洞洞杂货铺店铺设定"
        path="/"
        jsonLd={orgJsonLd}
      />
      <Hero />
      <CharactersSection />
      <RelationshipSection />
      <SettingPreview />
      <StoryPreview />
      <FaqSection />
      <CtaSection />
    </>
  );
}